import type { FaireProductEntity } from "../../entity_types/product";

export const p_wkc8qg6w3v: FaireProductEntity = {
  token: "p_wkc8qg6w3v",
  type: "product",
  name: "Espresso Concenrtate",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/ef6907414e11791b035fd5562ea3c6485154f8449409e76296f4ee340a421d92.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/957ae155b90c3f46c07751a12ee444907dcd696907f8a2b504141530419dfb09.png",
    "https://cdn.faire.com/fastly/c9cc0906bd50b56fbc5d0bb8a3320cd06896319e555cbfaced758393661d134e.png"
  ],
  priceDollars: 28.6,
  description: "Developed in collaboration with a Michelin Star hospitality program, our espresso concentrate was created to provide elevated quality, consistency and efficiency for world class bars. Simply add a pour spout, and your program is ready to serve espresso.",
  tags: [],
  msrpDollars: 57.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:12.398Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
